import Yup from '@/yup'
import {markRaw} from "vue";
import Intro from "../components/survey/parts/Intro";
import Outro from "../components/survey/parts/Outro";
import Objekttyp from "../components/survey/Objekttyp";
import StepsWrapper from "../components/survey/StepsWrapper";
import UnterkunftsTyp from "../components/survey/parts/UnterkunftsTyp";
import LokalTyp from "../components/survey/parts/LokalTyp";
import Zusatzunterkunft2 from "../components/survey/parts/Zusatzunterkunft2";
import BesonderesGebaeude from "../components/survey/parts/BesonderesGebaeude";
import Objektname from "../components/survey/parts/Objektname";
import Standort from "../components/general/Standort.vue";
import Zusatzobjekte from "../components/survey/parts/Zusatzobjekte";
import Urlaubsarten from "../components/survey/parts/Urlaubsarten";
import Freizeitanbieter from "../components/survey/parts/Freizeitanbieter";
import VeranstaltungKategorie from "../components/survey/parts/VeranstaltungKategorie";
import VeranstaltungTermin from "../components/survey/parts/VeranstaltungTermin";
import VeranstaltungOrt from "../components/survey/parts/VeranstaltungOrt";
import KunstKulturKategorie from "../components/survey/parts/KunstKulturKategorie";
import Text from "../components/survey/parts/Text";
import ClientData from "../components/survey/parts/ClientData.vue";

const yupRequiredString = Yup.string().required()
// const yupRequiredBoolean = Yup.boolean().required()
const yupRequiredBooleanString = Yup.string().required().oneOf(['true', 'false'])

// checkbox/radio values / select options
const valuesAndOptions = {
    zusatzunterkunft: [
        {
            key: 'ferienhaeuser',

            // AUTOGENERATED:
            // checked: `${checkbox.key}_checked`,
            // standort: `${checkbox.key}_standort`,
            // andere_orga: `${checkbox.key}_andere_orga`,
            // orga_name: `${checkbox.key}_orga_name`,
            // e.g. standort: 'fierienhaus_standort',
            label: 'Ferienhaus',
            count_label: 'Anzahl Ihrer Ferienhäuser an diesem Standort'
        },
        {
            key: 'schwimmende-unterkuenfte',
            label: 'Ferienhaus: Hausboot',
            count_label: 'Anzahl Ihrer Hausboote an diesem Standort'
        },
        {
            key: 'ferienwohnungen',
            label: 'Ferienwohnung',
            count_label: 'Anzahl Ihrer Ferienwohnungen an diesem Standort'
        },
        {
            key: 'hotels',
            label: 'Hotel',
            count_label: 'Anzahl Ihrer Hotels an diesem Standort'
        },
        {
            key: 'pensionen',
            label: 'Pension',
            count_label: 'Anzahl Ihrer Pensionen an diesem Standort'
        },
        {
            key: 'hostels',
            label: 'Hostel',
            count_label: 'Anzahl Ihrer Hostels an diesem Standort'
        },
        // {
        //   key: 'gruppenhaus',
        //   label: 'Gruppenhaus, Seminarhaus, Jugendherberge',
        //   count_label: 'Anzahl Ihrer Gruppenhäuser/Seminarhäuser/Jugendherbergen an diesem Standort'
        // },
        {
            key: 'familienferienstaetten',
            label: 'Familienferienstätten',
            count_label: 'Anzahl Ihrer Familienferienstätten an diesem Standort'
        },
        {
            key: 'seminarhaeuser',
            label: 'Seminarhäuser',
            count_label: 'Anzahl Ihrer Seminarhäuser an diesem Standort'
        },
        {
            key: 'jugendherberge',
            label: 'Jugendherberge',
            count_label: 'Anzahl Ihrer Jugendherbergen an diesem Standort'
        },
        // {
        //   key: 'camping_stellplatz',
        //   label: 'Camping Stellplatz',
        //   count_label: 'Anzahl Ihrer Camping Stellplätze an diesem Standort'
        // },
        // {
        //   key: 'camping_mietobjekt',
        //   label: 'Camping Mietobjekt',
        //   count_label: 'Anzahl Ihrer Camping Mietobjekte an diesem Standort'
        // },
    ],
    essen: [
        {
            key: 'restaurants',
            label: 'Restaurant'
        },
        {
            key: 'cafes',
            label: 'Café'
        },
        {
            key: 'nachtleben',
            label: 'Bar'
        },
        {
            key: 'erlebnisgastronomie',
            label: 'Erlebnisgastronomie'
        }
    ],
    freizeit: [
        {
            label: 'Erlebnisbad/Erlebnistherme',
            key: 'erlebnisbaeder'
        },
        {
            key: 'miniaturenparks',
            label: 'Miniaturenpark'
        },
        // https://www.manetservice.de/mantis/view.php?id=34287
        // https://admin2.manet.info/platform/categories?utf8=%E2%9C%93&search%5Bcategory_id%5D=289&columns=shortname&commit=anzeigen
        // # FIXME: Freizeit & Sport > Erlebnispark
        // # FIXME: Freizeit & Sport > Erlebnishöfe (freizeithoefe)
        // # FIXME: Sehenswürdigkeiten > Erlebnispark
        // # FIXME: Sehenswürdigkeiten > Erlebnishöfe
        {
            label: 'Erlebnispark/Erlebnishof',
            key: 'erlebnispark' // freizeithoefe?
        },
        {
            label: 'Freibad / Badestelle privat',
            key: 'badestellen'
        },
        {
            label: 'Sport & Fitnessraum/-kurse',
            key: 'sportraum_fitnessraum'
        },
        {
            // Streichelzoo ist nur Add-On
            label: 'Zoo / Tierpark / Wildpark / Aquarium',
            key: 'tiergaerten'
        },
        {
            label: 'Galerie',
            key: 'galerie'
        },
        {
            label: 'Kletterpark',
            key: 'klettern '
        },
        {
            label: 'Fahrgastschifffahrt',
            key: 'fahrgastschifffahrt'
        },
        {
            label: 'Sommerrodelbahn',
            key: 'rodeln '
        },
        {
            label: 'Bootsverleih (Kanu, Ruderboot, ...)',
            key: 'bootsverleihe'
        },
        {
            label: 'Bootsvercharterer (Motorboot, Segelboot...)',
            key: 'charter'
        },
        {
            label: 'großer Spielplatz (z.B. Abenteuerspielplatz)',
            key: 'spielplaetze'
        },
        {
            label: 'Boots-/Surfschule',
            key: 'segeln'
        },
        {
            label: 'Hofladen',
            key: 'hoflaeden'
        },
        {
            label: 'Liegeplätze für Boote',
            key: 'liegeplaetze'
        },
        {
            label: 'Geschäft - Regionalprodukte',
            key: 'landestypischeprodukte'
        },
        {
            label: 'Service für Boote',
            key: 'sportserviceboote'
        },
        {
            label: 'Geschäft - Kunsthandwerk',
            key: 'kunsthandwerk'
        },
        {
            label: 'Reitanlage',
            key: 'reiten'
        },
        {
            label: 'Ort für Veranstaltungen (z.B. Saal, Platz, Wiese, Club, Bühne)',
            key: 'veranstaltungszentren'
        },
        {
            label: 'Golfanlage',
            key: 'golf'
        },
        {
            label: 'Minigolf',
            key: 'minigolf'
        },
        {
            label: 'Stadtführungen / Reiseleiter / Tourenanbieter',
            key: 'stadtrundgaenge'
        },
        {
            label: 'Tennisplatz',
            key: 'tennis'
        },
        // { ANGEBOTE!?!
        //   label: 'Shuttle-Service',
        //   key: 'shuttle-services'
        // },
        {
            label: 'Radverleih',
            key: 'fahrradverleihe'
        },
        {
            label: 'Draisinebahn',
            key: 'draisine'
        },
        {
            label: 'Schmalspurbahn',
            key: 'schmalspurbahnen'
        },
        {
            label: 'Tschu-Tschu-Bahn',
            key: 'tschu-tschu-bahnen'
        },
        {
            label: 'Bowling/Kegeln',
            key: 'bowling'
        },
        {
            label: 'Rundflüge (Ballon/Flugzeug)',
            key: 'flugsport'
        },
        {
            label: 'Angelverleih/Angeltouren',
            key: 'angeln'
        },
        {
            label: 'Motorsport / Quadtouren',
            key: 'motorsport'
        },
        {
            label: 'Tauchschule/-verleih',
            key: 'tauchen'
        },
        {
            label: 'Funsport',
            key: 'funsport'
        },
    ],
    kunst_kultur: [
        {
            key: 'schloesser',
            label: 'Burg / Schloss'
        },
        {
            key: 'schlossanlage',
            label: 'Schlosspark / Gartenanlage'
        },
        {
            key: 'kirche',
            label: 'Kirchen / Klöster'
        },
        // { TODO: Fehlt im Admin2 / klären, ob sinnvoll
        //   key: 'baumwipfelpfad',
        //   label: 'Baumwipfelpfad'
        // },
        {
            key: 'erlebnispark',
            label: 'Erlebnishof / Erlebnispark'
        },
        {
            key: 'seebruecken',
            label: 'Seebrücke'
        },
        {
            key: 'herrenhaeuser',
            label: 'Guts- & Herrenhäuser'
        },
        {
            key: 'technischedenkmaeler',
            label: 'Technische Denkmäler'
        },
        {
            key: 'museum',
            label: 'Museum'
        },
        {
            key: 'muehlen',
            label: 'Windmühle, Wassermühle'
        },
        {
            key: 'aussichtsplattformen',
            label: 'Aussichtsplattform'
        },
        {
            key: 'aussichtspunkte',
            label: 'Aussichtspunkt'
        },
        {
            key: 'aussichtstuerme',
            label: 'Aussichtsturm'
        },
        {
            key: 'orchester',
            label: 'Theater'
        },
        {
            key: 'leuchttuerme',
            label: 'Leuchtturm'
        },
        {
            key: 'denkmaeler-skulpturen',
            label: 'Denkmal, Skulptur'
        },
        {
            key: 'naturparks',
            label: 'Naturparkzentrum'
        },
        {
            key: 'eisenbahn',
            label: 'historische Eisenbahn'
        },
        {
            key: 'kinos',
            label: 'Kino - nur kulturell'
        },
        {
            key: 'historische-gebaeude',
            label: 'historisches Gebäude'
        },
        // { // zoo ist nicht mehr per se sehenswert, sondern nur freizeit
        //   key: 'zoos',
        //   label: 'Zoo, Tierpark'
        // },
    ],

    besonderes_gebaeude: [
        {
            key: 'false',
            label: 'Nein',
        },
        {
            key: 'schloesser',
            label: 'Schloss / Burg',
        },
        {
            key: 'muehlen',
            label: 'Windmühle / Wassermühle',
        },
        {
            key: 'historische-gebaeude',
            label: 'Historisches Gebäude',
        },
        {
            key: 'leuchttuerme',
            label: 'Leuchttürme',
        },
        {
            key: 'herrenhaeuser',
            label: 'Gutshaus / Herrenhaus',
        },
        {
            key: 'bauernhoefe',
            label: 'Bauernhof',
        },
        {
            key: 'reiterhoefe',
            label: 'Reiterhof',
        },
    ],
}
valuesAndOptions.zusatzobjekte = [].concat(valuesAndOptions.essen).concat(valuesAndOptions.freizeit)

const checkboxValidations = {}
for (const [key, values] of Object.entries(valuesAndOptions)) {
    // console.log(`adding names & validations for ${key}`);
    var arrayLength = values.length;
    checkboxValidations[key] = {}
    for (var i = 0; i < arrayLength; i++) {
        const checkbox = values[i];
        checkbox.field_names = {
            checked: `${checkbox.key}_checked`,
            standort: `${checkbox.key}_standort`,
            andere_orga: `${checkbox.key}_andere_orga`,
            orga_name: `${checkbox.key}_orga_name`,
        }
        // checkboxValidations[key][checkbox.field_names.standort] = Yup.string().when(checkbox.field_names.checked, {
        //     is: (value) => { const x = value === 'true'; console.log("checking is", value, 'returning', x); return x; },
        //     then: yupRequiredBooleanString,
        // })
        // console.log(JSON.stringify(checkboxValidations[key]))
    }
}

const surveyConfig = {
    intro:
        {
            name: "intro",
            schema: {},
            component: markRaw(Intro),
        },
    personal_data:
        {
            name: "personal_data",
            schema: Yup.object().shape({
                name: yupRequiredString,
                phone: Yup.string().phone('DE', false, 'Bitte geben Sie eine gültige Telefonnummer ein.').label('Telefon'),
                address_street: yupRequiredString.label('Straße'),
                address_zip: yupRequiredString.label('Postleitzahl'),
                address_city: yupRequiredString.label('Ort'),
                address_country_code: yupRequiredString.label('Ländercode'),
            }),
            component: markRaw(ClientData),
        },
    objekttyp:
        {
            name: "objekttyp",
            schema: Yup.object().shape({
                objekttyp: yupRequiredString,
            }),
            options: {
                tipp: '<b>Tipp:</b> <br> Wenn Sie mehr vermarkten wollen, dann beginnen Sie mit der Auswahl, die am ehesten zu Ihnen passt. ',
            },
            component: markRaw(Objekttyp),
        },
    unterkunft: {
        component: markRaw(StepsWrapper),
        steps: [
            {
                schema: Yup.object().shape({
                    unterkunfts_typ: yupRequiredString,
                    besonderes_gebaeude: yupRequiredString.oneOf(valuesAndOptions.besonderes_gebaeude.map(v => v.key)),
                }),
                unterkunfts_typ: {
                    name: "unterkunfts_typ",
                    component: markRaw(UnterkunftsTyp),
                },
                besonderes_gebaeude: {
                    name: "besonderes_gebaeude",
                    component: markRaw(BesonderesGebaeude),
                    selectOptions: valuesAndOptions.besonderes_gebaeude,
                },
            },
            {
                schema: Yup.object().shape({
                    objektname: yupRequiredString,
                }),
                objektname: {
                    name: "objektname",
                    component: markRaw(Objektname)
                },
            },
            {
                schema: Yup.object().shape({
                    search: yupRequiredString.label('Adresse'),
                }),
                standort: {
                    name: "standort",
                    component: markRaw(Standort),
                    options: {
                        tipp: '<b>Hinweis:</b> Diese Lage wird Gästen auf unserer Seite angezeigt. Bitte geben Sie daher den Standort so akkurat wie möglich an.'
                    },
                },
            },
            {
                schema: Yup.object().shape(
                    Object.assign({
                            weitere_unterkuenfte: yupRequiredBooleanString,
                        },
                        checkboxValidations.zusatzunterkunft
                    ),
                ),
                weitere_unterkuenfte: {
                    name: "weitere_unterkuenfte",
                    component: markRaw(Zusatzunterkunft2),
                    options: {
                        storeKey: 'weitere_unterkuenfte',
                        question: "Haben Sie weitere Unterkünfte?",
                        tipp: '<b>Hinweise:</b> <br/> Sie können mehrfach auswählen. Speziell bei den Ferienwohnungen und Ferienhäusern benötigen wir neben der Standortabfrage, die Anzahl Ihrer Ferienwohnungen oder Ferienhäuser. Daraus ermitteln wir die Unterkünfte, die vermarktet werden können. Haben Sie einen anderen Standort ausgewählt, können Sie diesen später in der Unterkunftsbearbeitung eintragen.'
                    },
                    checkboxes: valuesAndOptions.zusatzunterkunft,
                },
            },
            {
                schema: Yup.object().shape({
                    zusatzobjekte: yupRequiredBooleanString,
                }),
                zusatzobjekte: {
                    name: "zusatzobjekte",
                    component: markRaw(Zusatzobjekte),
                    question: 'Haben Sie weitere Unterkünfte / Dienstleistungen, die zu Ihrer Unterkunft gehören?',
                    checkboxes: valuesAndOptions.zusatzobjekte,
                },
            },
            {
                schema: Yup.object().shape({
                    urlaubsart: Yup.array()
                }),
                urlaubsarten: {
                    name: "urlaubsarten",
                    component: markRaw(Urlaubsarten),
                },
            },
        ],


    },
    essen_trinken: {
        component: markRaw(StepsWrapper),
        steps: [
            {
                schema: Yup.object().shape({
                    lokal_typ: yupRequiredString,
                    besonderes_gebaeude: yupRequiredString,
                }),
                lokal_typ: {
                    name: "lokal_typ",
                    component: markRaw(LokalTyp),
                    selectOptions: valuesAndOptions.essen,
                },
                besonderes_gebaeude: {
                    name: "besonderes_gebaeude",
                    component: markRaw(BesonderesGebaeude),
                    selectOptions: valuesAndOptions.besonderes_gebaeude,
                },
            },
            {
                schema: Yup.object().shape({
                    objektname: yupRequiredString,
                }),
                objektname: {
                    name: "objektname",
                    component: markRaw(Objektname)
                },
            },
            {
                schema: Yup.object().shape({
                    search: yupRequiredString.label('Adresse'),
                }),
                standort: {
                    name: "standort",
                    component: markRaw(Standort),
                    options: {
                        tipp: '<b>Hinweis:</b> Diese Lage wird Gästen auf unserer Seite angezeigt. Bitte geben Sie daher den Standort so akkurat wie möglich an.'
                    },
                },
            },
            {
                schema: Yup.object().shape({
                    zusatzobjekte: Yup.string().notOneOf(
                        [
                            'null',
                        ])
                }),
                zusatzobjekte: {
                    name: "zusatzobjekte",
                    component: markRaw(Zusatzobjekte),
                    options: {
                        // tipp: '<b>Tipp:</b> Sie können auch später weitere Objekte hinzufügen.',
                    },
                    question: 'Haben Sie weitere Dienstleistungen, die zu Ihrem Lokal gehören?',
                    checkboxes: valuesAndOptions.freizeit,
                },
            },
            {
                schema: Yup.object().shape({
                    zusatzunterkunft: Yup.string().notOneOf(
                        [
                            'null',
                        ])
                }),
                zusatzunterkunft: {
                    name: "zusatzunterkunft",
                    component: markRaw(Zusatzunterkunft2),
                    options: {
                        storeKey: 'zusatzunterkunft',
                        // tipp: '<b>Tipp:</b> Sie können auch später weitere Objekte hinzufügen.',
                    },
                    checkboxes: valuesAndOptions.zusatzunterkunft,
                },
            },
            {
                schema: Yup.object().shape({
                    urlaubsart: Yup.array()
                }),
                urlaubsarten: {
                    name: "urlaubsarten",
                    component: markRaw(Urlaubsarten),
                },
            },
        ]
    },
    freizeitanbieter: {
        component: markRaw(StepsWrapper),
        steps: [
            {
                schema: Yup.object().shape({
                    freizeitanbieter: yupRequiredString,
                }),
                freizeitanbieter: {
                    name: "freizeitanbieter",
                    component: markRaw(Freizeitanbieter),
                    options: {
                        tipp: '<b>Tipp:</b> Sie können später weitere Kategorien hinzufügen',
                    },
                    radios: valuesAndOptions.freizeit,
                },
            },
            {
                schema: Yup.object().shape({
                    objektname: yupRequiredString,
                }),
                objektname: {
                    name: "objektname",
                    component: markRaw(Objektname)
                },
            },
            {
                schema: Yup.object().shape({
                    search: yupRequiredString.label('Adresse'),
                }),
                standort: {
                    name: "standort",
                    component: markRaw(Standort),
                    options: {
                        tipp: '<b>Hinweis:</b> Diese Lage wird Gästen auf unserer Seite angezeigt. Bitte geben Sie daher den Standort so akkurat wie möglich an.'
                    },
                },
            },
            {
                schema: {},
                freizeitanbieter_weitere: {
                    name: "freizeitanbieter_weitere",
                    component: markRaw(Freizeitanbieter),
                    type: 'multi',
                    checkboxes: valuesAndOptions.zusatzobjekte,
                },
            },
            {
                schema: Yup.object().shape({
                    zusatzunterkunft: Yup.string().notOneOf(
                        [
                            'null',
                        ])
                }),
                zusatzunterkunft: {
                    name: "zusatzunterkunft",
                    component: markRaw(Zusatzunterkunft2),
                    options: {
                        storeKey: "zusatzunterkunft",
                        // tipp: '<b>Tipp:</b> Sie können auch später weitere Objekte hinzufügen.',
                    },
                    checkboxes: valuesAndOptions.zusatzunterkunft,
                },
            },
            {
                schema: Yup.object().shape({
                    urlaubsart: Yup.array()
                }),
                urlaubsarten: {
                    name: "urlaubsarten",
                    component: markRaw(Urlaubsarten),
                },
            },
        ]
    },
    veranstaltung: {
        component: markRaw(StepsWrapper),
        steps: [
            {
                schema: Yup.object().shape({
                    veranstaltung_kategorie: yupRequiredString,
                }),
                veranstaltung_kategorie: {
                    name: "veranstaltung_kategorie",
                    component: markRaw(VeranstaltungKategorie),
                },
            },
            {
                schema: Yup.object().shape({
                    objektname: yupRequiredString,
                }),
                objektname: {
                    name: "objektname",
                    component: markRaw(Objektname),
                    type: 'event'
                },
            },
            {
                schema: Yup.object().shape({
                    veranstaltung_terminart: Yup.string().required(
                        'Bitte wählen Sie Zeitraum oder Einzeltermine aus.'
                    ),
                    veranstaltung_termin: Yup.string().nullable().test(
                        'required-date-for-schedule-type',
                        function (value) {
                            const scheduleType = this.parent.veranstaltung_terminart
                            if (!scheduleType || value) {
                                return true
                            }

                            return this.createError({
                                message: scheduleType === 'einzeltermin'
                                    ? 'Bitte geben Sie das Datum des ersten Termins ein.'
                                    : 'Bitte geben Sie ein Startdatum ein.',
                            })
                        }
                    ),
                    veranstaltung_endtermin: Yup.string().when('veranstaltung_terminart', {
                        is: 'zeitraum',
                        then: schema => schema.required(
                            'Bitte geben Sie ein Enddatum ein.'
                        ).test(
                            'after-start',
                            'Das Enddatum muss am oder nach dem Startdatum liegen.',
                            function (value) {
                                return !value || !this.parent.veranstaltung_termin || value >= this.parent.veranstaltung_termin
                            }
                        ),
                        otherwise: schema => schema.nullable(),
                    }),
                    veranstaltung_uhrzeit: Yup.string().when('veranstaltung_terminart', {
                        is: 'einzeltermin',
                        then: schema => schema.required(
                            'Bitte geben Sie eine Uhrzeit ein.'
                        ),
                        otherwise: schema => schema.nullable(),
                    }),
                }),
                veranstaltung_termin: {
                    name: "veranstaltung_termin",
                    component: markRaw(VeranstaltungTermin),
                },
            },
            {
                schema: Yup.object().shape({
                    search: yupRequiredString.label('Adresse'),
                }),
                veranstaltung_inhaber: {
                    name: "veranstaltung_inhaber",
                    component: markRaw(VeranstaltungOrt),
                },
            },
            {
                schema: Yup.object().shape({
                    zusatzunterkunft: Yup.string().notOneOf(
                        [
                            'null',
                        ])
                }),
                zusatzunterkunft: {
                    name: "zusatzunterkunft",
                    component: markRaw(Zusatzunterkunft2),
                    options: {
                        storeKey: 'zusatzunterkunft',
                        // tipp: '<b>Tipp:</b> Sie können auch später weitere Objekte hinzufügen.',
                    },
                    checkboxes: valuesAndOptions.zusatzunterkunft,
                },
            },
            {
                schema: Yup.object().shape({
                    urlaubsart: Yup.array()
                }),
                urlaubsarten: {
                    name: "urlaubsarten",
                    component: markRaw(Urlaubsarten),
                },
            },
        ]
    },
    kunst_kultur: {
        component: markRaw(StepsWrapper),
        steps: [
            {
                schema: Yup.object().shape({
                    kunst_kultur_kategorie: yupRequiredString,
                }),
                kunst_kultur_kategorie: {
                    name: "kunst_kultur_kategorie",
                    component: markRaw(KunstKulturKategorie),
                    radios: valuesAndOptions.kunst_kultur,
                },
            },
            {
                schema: Yup.object().shape({
                    objektname: yupRequiredString,
                }),
                objektname: {
                    name: "objektname",
                    component: markRaw(Objektname)
                },
            },
            {
                schema: Yup.object().shape({
                    search: yupRequiredString.label('Adresse'),
                }),
                standort: {
                    name: "standort",
                    component: markRaw(Standort),
                    options: {
                        tipp: '<b>Hinweis:</b> Diese Lage wird Gästen auf unserer Seite angezeigt. Bitte geben Sie daher den Standort so akkurat wie möglich an.'
                    },
                },
            },
            {
                schema: Yup.object().shape({
                    zusatzunterkunft: Yup.string().notOneOf(
                        [
                            null,
                        ])
                }),
                zusatzunterkunft: {
                    name: "zusatzunterkunft",
                    component: markRaw(Zusatzunterkunft2),
                    options: {
                        storeKey: 'zusatzunterkunft',
                        // tipp: '<b>Tipp:</b> Sie können auch später weitere Objekte hinzufügen.',
                    },
                    checkboxes: valuesAndOptions.zusatzunterkunft,
                },
            },
            {
                schema: Yup.object().shape({
                    zusatzobjekte: Yup.string().notOneOf(
                        [
                            'null',
                        ])
                }),
                zusatzobjekte: {
                    name: "zusatzobjekte",
                    component: markRaw(Zusatzobjekte),
                    options: {
                        tipp: '<b>Tipp:</b> Sie können auch später weitere Unterkünfte hinzufügen',
                    },
                },
            },
        ]
    },
    nichts: {
        component: markRaw(StepsWrapper),
        steps: [
            {
                schema: Yup.object().shape({
                    objektname: yupRequiredString,
                }),
                objektname: {
                    name: "objektname",
                    component: markRaw(Objektname)
                },
            },
            {
                schema: Yup.object().shape({
                    search: yupRequiredString.label('Adresse'),
                }),
                standort: {
                    name: "standort",
                    component: markRaw(Standort),
                    options: {
                        tipp: '<b>Hinweis:</b> Diese Lage wird Gästen auf unserer Seite angezeigt. Bitte geben Sie daher den Standort so akkurat wie möglich an.'
                    },
                },
            },
            {
                schema: Yup.object().shape({
                    selbstbeschreibung: yupRequiredString,
                }),
                selbstbeschreibung: {
                    name: "selbstbeschreibung",
                    component: markRaw(Text),
                },
            },
        ]
    },
    outro: {
        name: "outro",
        schema: {},
        component: markRaw(Outro),
    },
}


// export default surveyConfig;
export {surveyConfig, valuesAndOptions};
